import BaseModel from './BaseModel'
import {db} from '../utilities'

export default class TicketComments extends BaseModel {
    constructor (id: string) {
        super(db.collection('tickets').doc(id).collection('comments'))
    }
}